var map = {
	"./prize-1.json": 172,
	"./prize-1@2x.json": 174,
	"./prize-2.json": 176,
	"./prize-2@2x.json": 178,
	"./prize-3.json": 180,
	"./prize-3@2x.json": 182,
	"./prize-4.json": 184,
	"./prize-4@2x.json": 186,
	"./prize-5.json": 188,
	"./prize-5@2x.json": 190,
	"./prize-6.json": 192,
	"./prize-6@2x.json": 194,
	"./prize-7.json": 196,
	"./prize-7@2x.json": 198,
	"./prize-8.json": 200,
	"./prize-8@2x.json": 202,
	"./prize-9.json": 204,
	"./prize-9@2x.json": 206
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 264;



//////////////////
// WEBPACK FOOTER
// ./themes/hm/sprite ^\.\/prize\-.*\.json$
// module id = 264
// module chunks = 3